import { gsap } from 'gsap'

export class OpencampusSchedule {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('js-opencampus_schedule') === null) return
      const Ease = {
        easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
      }
      let duration = 500
      const wrap = document.querySelector('.js-opencampus_schedule')
      const card = wrap.querySelectorAll('.p-opencampus_schedule__card')
      const cardList = Array.prototype.slice.call(card, 0)
      const trg = document.querySelector('.js-opencampus_more')
      const num = 4
      let trgPosition = window.pageYOffset + wrap.getBoundingClientRect().top - 115
      let currentPostion = document.documentElement.scrollTop

      if (window.innerWidth < 768) {
        cardList.forEach((elm, i) => {
          if (i + 1 > num) {
            elm.style.display = 'none'
          }
        })
        trg.addEventListener('click', (event) => {
          let $this = event.currentTarget
          if ($this.classList.contains('is-act')) {
            $this.classList.remove('is-act')
            cardList.forEach((elm, i) => {
              if (i + 1 > num) {
                gsap.to(elm, { opacity: 0, display: 'none' })
              }
            })
            //スムーススクロール
            var startTime = performance.now()
            var loop = function (nowTime) {
              var time = nowTime - startTime
              var normalizedTime = time / duration

              if (normalizedTime < 1) {
                window.scrollTo(0, currentPostion + (trgPosition - currentPostion) * Ease.easeInOut(normalizedTime))
                requestAnimationFrame(loop)
              } else {
                window.scrollTo(0, trgPosition)
              }
            }
            requestAnimationFrame(loop)
          } else {
            $this.classList.add('is-act')
            cardList.forEach((elm) => {
              gsap.to(elm, { opacity: 1, display: 'block' })
            })
          }
        })
      }
    })
  }
}
